module.exports = __webpack_public_path__ + "img/pencil-alt.9c84e04a.svg";